import { z } from 'zod';
import { normalizePhone } from '../phone.js';

/**
 * The phone numbers and opening hours shown at the top of the storefront ("Call us"). Staff edit them in
 * the admin; these are the numbers used until they do.
 */
export const SUPPORT_MAX_PHONES = 3;
export const SUPPORT_HOURS_MAX = 60;

export const DEFAULT_SUPPORT = {
  phones: ['+919793397935', '+918295697935'],
  hours: 'Mon-Fri, 9am-6pm',
} as const;

export const supportSchema = z.object({
  phones: z
    .array(
      z
        .string()
        .trim()
        .min(1)
        .transform((v, ctx) => {
          const normalized = normalizePhone(v);
          if (!normalized) {
            ctx.addIssue({ code: 'custom', message: `"${v}" is not a valid mobile number` });
            return z.NEVER;
          }
          return normalized;
        }),
    )
    .max(SUPPORT_MAX_PHONES, `Add at most ${SUPPORT_MAX_PHONES} numbers`)
    .refine((list) => new Set(list).size === list.length, 'Each number can be listed once'),
  hours: z.string().trim().max(SUPPORT_HOURS_MAX).default(''),
});

export type SupportInput = z.input<typeof supportSchema>;
export type SupportDTO = { phones: string[]; hours: string };
